import { render, staticRenderFns } from "./EarlyCollegeSummitSponsorshipPortal2025Terms.vue?vue&type=template&id=2c87a80d&scoped=true"
import script from "./EarlyCollegeSummitSponsorshipPortal2025Terms.vue?vue&type=script&lang=js"
export * from "./EarlyCollegeSummitSponsorshipPortal2025Terms.vue?vue&type=script&lang=js"
import style0 from "./EarlyCollegeSummitSponsorshipPortal2025Terms.vue?vue&type=style&index=0&id=2c87a80d&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c87a80d",
  null
  
)

export default component.exports